module.exports = __webpack_public_path__ + "static/img/home7.c6a1c1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/home7.jpg
// module id = LyYf
// module chunks = 0